// extracted by mini-css-extract-plugin
export var active = "_h7-7";
export var blink = "_h7-8";
export var dropDownSelector = "_h7-4";
export var dropDownWrapper = "_h7-3";
export var fakeCursor = "_h7-6";
export var fontSizeButton = "_h7-9";
export var formQuillEditor = "_h7-0";
export var pressed = "_h7-a";
export var qlBlank = "_h7-1";
export var textFormattingToolbar = "_h7-2";
export var textToolbarOption = "_h7-5";